import request from "@/plugins/axios/courseApi.js";

// 创建虚拟仿真课程
export function createVirtualCourse (data) {
  return request({
    url: `/virtualReality/create/course`,
    method: 'post',
    data
  })
}

// 查询虚拟仿真课程列表
export function getCourseList (params) {
  return request({
    url: `/virtualReality/course/list`,
    method: 'get',
    params
  })
}

// 发布虚拟仿真课程
export function publishVirtualCourse (courseId) {
  return request({
    url: `/virtualReality/publish/course/${courseId}`,
    method: 'put',
  })
}

// 撤回虚拟仿真课程
export function revokeVirtualCourse (courseId) {
  return request({
    url: `/virtualReality/revoke/course/${courseId}`,
    method: 'put',
  })
}

// 删除虚拟仿真课程
export function deleteVirtualCourse (courseId) {
  return request({
    url: `/virtualReality/delete/course/${courseId}`,
    method: 'delete',
  })
}

// 更新虚拟仿真课程
export function updateVirtualCourse (courseId) {
  return request({
    url: `/virtualReality/update/course/${courseId}`,
    method: 'put',
  })
}

// 查询课程团队成员
export function getTeamTea (params) {
  return request({
    url: `/virtualReality/team/teacher`,
    method: 'get',
    params
  })
}

// 保存或修改课程团队成员
export function saveTeamTea (data, courseId) {
  return request({
    url: `/virtualReality/save/team/teacher/${courseId}`,
    method: 'post',
    data
  })
}

// 保存或修改课程基本信息
export function saveCourseInfo (data) {
  return request({
    url: `/virtualReality/save/course/info`,
    method: 'post',
    data
  })
}

// 查询课程基本信息
export function getCourseInfo (params) {
  return request({
    url: `/virtualReality/course/info`,
    method: 'get',
    params
  })
}

// 查询课程实验资源
export function getCourseExperimentResources (params) {
  return request({
    url: `/virtualReality/course/experiment/resources`,
    method: 'get',
    params
  })
}

// 搜索课程资源
export function searchCourseContentResources (params) {
  return request({
    url: `/course/content/order`,
    method: 'get',
    params: {
      ...params,
      lang: 'zh'
    }
  })
}

// 保存上传后的课程资源内容
export function saveCourseContent (data) {
  return request({
    url: `/course/content/upload`,
    method: 'post',
    params: {
      lang: 'zh'
    },
    data
  })
}

// 关联资源内容到实验同步文件夹（班课资源）
export function relateCourseContent (data) {
  return request({
    url: `/course/content/experiment`,
    method: 'post',
    params: {
      lang: 'zh'
    },
    data
  })
}

// 编辑课程资源或文件夹名称
// axiosConfig 可传 skipCourseApiErrorToast，避免 400 时全局 toast，由页面内联展示
export function editCourseContent (data, axiosConfig = {}) {
  return request({
    url: `/course/content/editor`,
    method: 'post',
    params: {
      lang: 'zh'
    },
    data,
    ...axiosConfig
  })
}

/**
 * 批量删除课程资源（请求体为资源 id 列表，对应后端 @RequestBody List<Integer> ids）
 */
export function deleteCourseContent (ids) {
  return request({
    url: `/course/content/delete`,
    method: 'post',
    params: {
      lang: 'zh'
    },
    data: ids
  })
}

/**
 * 编辑实验同步文件夹内资源，并回写 AI 实验附件（与 /virtualReality/experiment/info 的 fileList 一致）
 * axiosConfig 可传 skipCourseApiErrorToast，避免 400 时全局 toast，由页面内联展示
 */
export function editExperimentSyncedCourseContent (data, axiosConfig = {}) {
  return request({
    url: `/course/content/experiment/editor`,
    method: 'post',
    params: {
      lang: 'zh'
    },
    data,
    ...axiosConfig
  })
}

/**
 * 删除实验同步文件夹内资源，并同步逻辑删除 AI 实验附件（请求体为资源 id 列表）
 */
export function deleteExperimentSyncedCourseContent (ids) {
  return request({
    url: `/course/content/experiment/delete`,
    method: 'post',
    params: {
      lang: 'zh'
    },
    data: ids
  })
}

/**
 * 课程资源条目详情（列表行 id 多为关联 id）
 * GET /course/content/:id ，与班课后台一致附带 resourceFlag / lang / shareType
 */
export function getCourseContentDetail (id, params = {}) {
  return request({
    url: `/course/content/${id}`,
    method: 'get',
    params: {
      lang: 'zh',
      resourceFlag: 2,
      shareType: '',
      ...params
    }
  })
}

/** OBS 浏览器下载凭证：GET /obs/downloadToken?path=resources/web/xxx（返回临时密钥供 ulearning-obs 下载） */
export function getObsDownloadToken (path) {
  return request({
    url: `/obs/downloadToken`,
    method: 'get',
    params: { path }
  })
}

// 创建虚拟仿真实验
export function saveExperiment (data) {
  return request({
    url: `/virtualReality/save/experiment`,
    method: 'post',
    data
  })
}

// 在课程中查询虚拟仿真实验列表
export function getCourseExperimentList (params) {
  return request({
    url: `/virtualReality/course/experiment/list`,
    method: 'get',
    params
  })
}

// 删除虚拟仿真实验
export function deleteExperiment (experimentId) {
  return request({
    url: `/virtualReality/delete/experiment/${experimentId}`,
    method: 'delete',
  })
}

// 查询虚拟仿真实验详情V2
export function getExperimentDetails (params) {
  return request({
    url: `/virtualReality/experiment/details/v2`,
    method: 'get',
    params
  })
}

// 编辑虚拟仿真
export function updateExperiment (data) {
  return request({
    url: `/virtualReality/update/experiment`,
    method: 'post',
    data
  })
}

// 编辑虚拟仿真基本信息
export function experimentBaseInfo (data) {
  return request({
    url: `/virtualReality/update/experiment/baseInfo`,
    method: 'post',
    data
  })
}

// 编辑虚拟仿真实验介绍
export function experimentIntroduce (data) {
  return request({
    url: `/virtualReality/update/experiment/introduce`,
    method: 'post',
    data
  })
}

// 编辑虚拟仿真实验必读
export function experimentMustRead (data) {
  return request({
    url: `/virtualReality/update/experiment/mustRead`,
    method: 'post',
    data
  })
}

// 查询虚拟仿真课程详情
export function getCourseDetails (params) {
  return request({
    url: `/virtualReality/course/details`,
    method: 'get',
    params
  })
}

// 教师端获取学生的实验成绩列表
export function getVirtualGradeList(params) {
  return request({
    url: `/virtualReality/tea/scoreList`,
    method: 'get',
    params
  })
}

// 教师端获取学生实验的成绩详情
export function getStuVirtualGradeDetailByTea(params) {
  return request({
    url: `/virtualReality/records/tea`,
    method: 'get',
    params
  })
}

// 学生获取学生实验的成绩详情
export function getStuVirtualGradeDetailByStu(params) {
  return request({
    url: `/virtualReality/records/stu`,
    method: 'get',
    params
  })
}

// 获取三方虚拟仿真实验地址
export function getVirtualExperimentUrl(params) {
  return request({
    url: `/virtualReality/url`,
    method: 'get',
    params
  })
}

// 门户获取实验详情
export function getVirtualExperimentDetail(params) {
  return request({
    url: `/virtualReality/experiment/details`,
    method: 'get',
    params
  })
}

// 进入门户实验详情记录浏览量埋点
export function updateVirtualHomeViewTimes(params) {
  return request({
    url: `/virtualReality/record/experiment/visitor`,
    method: 'get',
    params
  })
}

// 教师重新评分获取分数详情
export function experimentScoreDetails(params) {
  return request({
    url: `/virtualReality/experiment/score/details`,
    method: 'get',
    params
  })
}

// 教师重新评分
export function experimentTeaMark(params) {
  return request({
    url: `/virtualReality/experiment/tea/again/mark`,
    method: 'get',
    params
  })
}

// 查询虚拟仿真信息
export function getExperimentInfo(params) {
  return request({
    url: `/virtualReality/experiment/info`,
    method: 'get',
    params
  })
}

// 查询用户新建虚拟仿真课程权限
export function getUserRoot() {
  return request({
    url: `/virtualReality/userRoot`,
    method: 'get',
  })
}

// 获取tonglab实验列表
export function getTonglabExperiments(params) {
  return request({
    url: `/virtualReality/tonglab/experiments`,
    method: 'get',
    params
  })
}

//转存tonglab实验到课程实验
export function transferTonglabExperiment(experimentId, params) {
  return request({  
    url: `/virtualReality/tonglab/experiment/${experimentId}/transfer`,
    method: 'post',
    params
  })
}

//获取tonglab ticket
export function getTonglabTicket() {
  return request({  
    url: `/virtualReality/tonglabticket`,
    method: 'get'
  })
}

